export const markSize = 40 // mark icon size
export const markAreaStep = 60 // distance between mark groups
export const minDraggerHeight = 30
export const bookContainerSelector = 'div.epub-container'

export const ANNOTATION_STATES = {
  INACTIVE: 'INACTIVE',
  HIGHLIGHT: 'HIGHLIGHT',
  HIGHLIGHTED: 'HIGHLIGHTED',
  NOTE: 'NOTE',
  NOTE_GROUP: 'NOTE_GROUP',
}

export const ANNOTATION_EVENTS = {
  SELECTED: 'SELECTED',
  HIHLIGHT: 'HIHLIGHT',
  ADD_NOTE: 'ADD_NOTE',
  HIGHLIGHT_CLICK: 'HIGHLIGHT_CLICK',
  HIGHLIGHTED: 'HIGHLIGHTED',
  MARK_CLICK: 'MARK_CLICK',
  MARK_GROUP_CLICK: 'MARK_GROUP_CLICK',
  SAVE: 'SAVE',
  DELETE: 'DELETE',
  CLICK_OUTSIDE: 'CLICK_OUTSIDE',
}

export const ANNOTATION_TYPES = {
  HIGHLIGHT: 'highlight',
  MARK: 'mark',
}
